import React from "react";
import { LazyLoadImage, LinkButton } from "../../../../../core/atoms";
import { RoutesInvoker } from "../../../../routesInvoker";
import "./worldwideTeam.scss";

export const WorldwideTeam = () => {
  const images = [
    {
      src: "https://resources.travellocal.com/lto/09a32e27-217b-4328-91f5-50a74f405363_thumb",
      alt: "Some of the people that make up our worldwide team",
      className: "show-on-mobile show-on-tablet",
    },
    {
      src: "https://resources.travellocal.com/lto/04717d0b-6aa9-49e9-b8ba-88de527720f3-VE5A8334_thumb.jpg",
      alt: "Some of the people that make up our worldwide team",
      className: "show-on-mobile show-on-tablet",
    },
    {
      src: "https://resources.travellocal.com/lto/7bef4f74-e4a1-4d76-acc2-77fd2b078734-South_Africa_Tailor_Made_Safaris_team_photo_thumb.jpg",
      alt: "Some of the people that make up our worldwide team",
      className: "show-on-mobile show-on-tablet",
    },
    {
      src: "https://resources.travellocal.com/lto/2e25a359-e579-48c5-affe-dd2aa86f0a0d-team-photo-viare-brazil-LTO_thumb.jpg",
      alt: "Some of the people that make up our worldwide team",
      className: "show-on-mobile show-on-tablet",
    },
    {
      src: "https://resources.travellocal.com/lto/d8826429-6f1e-4d07-9551-03406a7baf40_thumb",
      alt: "Some of the people that make up our worldwide team",
      className: "",
    },
    {
      src: "https://resources.travellocal.com/lto/69fb864c-8098-46c0-8434-faa02b025acc_thumb",
      alt: "Some of the people that make up our worldwide team",
      className: "",
    },
    {
      src: "https://resources.travellocal.com/lto/2329dc53-0939-42a5-a7e5-a8ab419ce601-Kamino_Tours_Team_foto_thumb.jpg",
      alt: "Some of the people that make up our worldwide team",
      className: "",
    },
    {
      src: "https://resources.travellocal.com/lto/68e6fae6-388e-41aa-a56b-081e88c7721e-Rachel_and_Steve_thumb.jpg",
      alt: "Some of the people that make up our worldwide team",
      className: "",
    },
    {
      src: "https://resources.travellocal.com/lto/dea89ed7-6013-4fb5-8e2d-cbcafa48927c-team-the-safari-company-kenya-LTO_thumb.jpg",
      alt: "Some of the people that make up our worldwide team",
      className: "",
    },
  ];

  const renderImages = () =>
    images.map(({ src, alt, className }) => {
      const imageSrc: ISrcSet = {
        default: src,
        srcs: [
          {
            src,
            width: 256, // Intrinsic width
          },
        ],
      };

      return (
        <div key={src} className={`worldwide-team__image-grid-item ${className}`}>
          <LazyLoadImage src={imageSrc} className="worldwide-team__image" alt={alt} />
        </div>
      );
    });

  return (
    <div className="worldwide-team about-bottom-boundary width-wrapper">
      <div className="columns">
        <div className="column is-8-tablet is-offset-4-tablet is-7-desktop is-offset-3-desktop">
          <div className="worldwide-team__inner">
            <div className="worldwide-team__image-grid">
              {renderImages()}
            </div>
            <div className="worldwide-team__content">
              <h2 className="worldwide-team__title">Our worldwide team</h2>
              <p className="worldwide-team__text">We have carefully selected local travel companies from all over the world.{` `}
              Being on the ground in your destination, our partners are best placed to plan your perfect holidays.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
